import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { useLanguage } from '@/context/LanguageContext';
import { Scale, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Impressum = () => {
  const { t, language } = useLanguage();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/pages/impressum`);
        setPage(response.data);
      } catch (error) {
        console.error('Error fetching page:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  const title = page ? (language === 'fr' ? page.title_fr : (page.title_de || page.title_fr)) : 'Impressum';
  const content = page ? (language === 'fr' ? page.content_fr : (page.content_de || page.content_fr)) : '';

  return (
    <Layout>
      <section className="py-20 md:py-32 bg-slate-50">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 mb-8">
            <Scale className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 font-outfit" data-testid="impressum-title">
              Impressum
            </h1>
          </div>

          {loading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-slate-200 p-8 md:p-12">
              <div className="prose prose-slate max-w-none" data-testid="impressum-content">
                {content ? (
                  content.split('\n').map((paragraph, index) => (
                    paragraph.trim() && (
                      <p key={index} className="text-slate-700 leading-relaxed mb-4">
                        {paragraph}
                      </p>
                    )
                  ))
                ) : (
                  <>
                    <h2 className="text-xl font-bold text-slate-900 mt-2 mb-4 font-outfit">
                      Angaben gemäß § 5 TMG
                    </h2>
                    <p className="text-slate-700 mb-6">Josias Djotchou</p>

                    <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4 font-outfit">Kontakt</h2>
                    <p className="text-slate-700">
                      {t('Über das Kontaktformular der Website', 'Via le formulaire de contact du site')}
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4 font-outfit">
                      {t('Haftung für Inhalte', 'Responsabilité pour le contenu')}
                    </h2>
                    <p className="text-slate-700">
                      {t(
                        'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.',
                        'En tant que prestataire de services, nous sommes responsables de notre propre contenu sur ces pages conformément à la loi allemande.'
                      )}
                    </p>

                    <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4 font-outfit">
                      {t('Haftung für Links', 'Responsabilité pour les liens')}
                    </h2>
                    <p className="text-slate-700">
                      {t(
                        'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.',
                        'Notre offre contient des liens vers des sites web externes de tiers sur le contenu desquels nous n\'avons aucune influence.'
                      )}
                    </p>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default Impressum;
